const NEW_BOOKING_STEPS = Object.freeze({
    ownerPetDetails: {
        hash: '#owner-pet-details',
        name: 'ownerPetDetails',
        label: 'Owner and pet details',
        title: 'Owner and pet details'
    },
    productList: {
        hash: '#product-list',
        name: 'productList',
        label: 'Product details',
        title: 'Select Items'
    },
    keepsakes: {
        hash: '#keepsakes',
        name: 'keepsakes',
        label: 'Keepsakes',
        title: 'Keepsake options'
    },
    urn: {
        hash: '#urn',
        name: 'urn',
        label: 'Urn',
        title: 'Urn options'
    },
    memorialisation: {
        hash: '#memorialisation',
        name: 'memorialisation',
        label: 'Memorialisation',
        title: 'Memorialisation options'
    },
    bundle: {
        hash: '#bundle',
        name: 'bundle',
        label: 'Package details',
        title: 'Package options'
    },
    item: {
        hash: '#item',
        name: 'item',
        label: 'Item Selection',
        title: 'Item selection'
    },
    confirmation: {
        hash: '#confirmation',
        name: 'confirmation',
        label: 'Confirmation',
        title: 'Confirmation'
    }
});

export default NEW_BOOKING_STEPS;
